import {
  Breakpoints,
  BreakpointWrapper,
  Container,
  ContainerGutter,
  Divider,
  styled,
  Text,
  TokenTextAppearance,
  TextTag,
} from '@volkswagen-onehub/components-core';
import React, {useContext, useEffect, useState} from 'react';
import {VehicleCategory} from '../../../types/enums/vehicles';
import {formatDistance} from '../../../utils/format';
import {LikeButton} from '../../LikeButton';
import {CardetailsInterface} from '../../../Details/CarDetails';
import {getLang} from '../../../translations';
import VehicleInventoryType, {getVehicleStatus} from './VehicleInventoryType';
import {
  ResultsView,
  ResultsViewContext,
} from '../../../utils/results-view-context';
import Proximity from '../../Proximity';
import DealerInformation from '../../DealerInformation';
import { DealerData } from '../../../types';

export const HeadlineContainer = styled.div``;

const StyledContainer = styled.div`
  > div {
    overflow: visible;
  }
`;

interface HeadlineInterface extends CardetailsInterface {
  dealer?: DealerData;
  isDetailPage?: boolean;
}

export default ({dealer, vehicle, isDetailPage}: HeadlineInterface) => {
  const lang = getLang();
  const view = useContext(ResultsViewContext).value;
  const vehicle_name =
    lang === 'fr'
      ? `${vehicle.model_name} ${vehicle.year}`
      : `${vehicle.year} ${vehicle.model_name}`;

  const [engine_name, set_engine_name] = useState<string | null>(null);

  useEffect(() => {
    if (!vehicle || !lang) return;
    let engineName = '';
    engineName += vehicle?.engine[lang] ? vehicle?.engine[lang] : '';
    engineName += ' ';
    engineName += vehicle?.trim[lang] ? vehicle?.trim[lang] : '';
    set_engine_name(engineName);
  }, [vehicle, lang]);

  const vehicleStatus = getVehicleStatus(vehicle);

  const getModelNameTextAppearance = () => {
    if (view === ResultsView.LIST) {
      return TokenTextAppearance.headline300;
    }
    return TokenTextAppearance.headline200;
  };

  return (
    <HeadlineContainer>
      <Container gutter={ContainerGutter.static100} wrap="always">
        {vehicle.category && isDetailPage && (
          <VehicleInventoryType
            category={vehicle.category}
            demo={vehicle.demo}
            vehicleStatus={vehicleStatus}
          />
        )}

        <Text bold tag={TextTag.h2} appearance={getModelNameTextAppearance()}>
          {vehicle_name}
        </Text>

        <Container
          wrap={
            view == ResultsView.GRID
              ? 'always'
              : {
                  [Breakpoints.default]: 'always',
                  [Breakpoints.b560]: 'auto',
                }
          }
          gutter={
            view == ResultsView.LIST
              ? {
                  [Breakpoints.default]: ContainerGutter.static100,
                  [Breakpoints.b560]: ContainerGutter.static200,
                }
              : ContainerGutter.static100
          }
        >
          {engine_name && (
            <Text
              bold={!isDetailPage}
              appearance={
                view === ResultsView.LIST &&
                window.innerWidth > Breakpoints.b560 &&
                isDetailPage
                  ? TokenTextAppearance.headline300
                  : TokenTextAppearance.headline100
              }
            >
              {engine_name}
            </Text>
          )}

          {view === ResultsView.LIST &&
            vehicle?.category != VehicleCategory.NEW &&
            vehicle?.category != VehicleCategory.DEMO && (
              <BreakpointWrapper min={Breakpoints.b560}>
                <Divider isVertical />
              </BreakpointWrapper>
            )}

          {vehicle?.category != VehicleCategory.NEW &&
          vehicle?.category != VehicleCategory.DEMO ? (
            <Text bold={!isDetailPage} appearance={isDetailPage ? TokenTextAppearance.headline300 : TokenTextAppearance.headline100}>
              {formatDistance(Number(vehicle?.mileage), lang)}
            </Text>
          ) : null}
        </Container>

        {isDetailPage && <Proximity />}

        {dealer && (
          <StyledContainer>
            <Container horizontalAlign="space-between" verticalAlign="center">
              <DealerInformation dealer={dealer} isDetailPage={isDetailPage} />
              <LikeButton
                vin={vehicle.vin || vehicle.stock_number}
                ariaModel={
                  lang == 'fr'
                  ? vehicle.model_name +
                    ' ' +
                    vehicle.trim['fr'] +
                    ' ' +
                    vehicle.year
                  : vehicle.year +
                    ' ' +
                    vehicle.model_name +
                    ' ' +
                    vehicle.trim['en']
                }
              />
            </Container>
          </StyledContainer>
        )}
      </Container>
    </HeadlineContainer>
  );
};
